export function error(message) {
  throw new Error(`[pit-bim-win-ui] ${message}`);
}

export function warn(message) {
  typeof console !== "undefined" && console.warn(`[pit-bim-win-ui] ${message}`);
}
